// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__KakyY","footer__copyright":"Footer_footer__copyright__DA1Pc"};